module.exports = __webpack_public_path__ + "img/canvasMenuSticking.2f5c6b67.svg";